var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Next"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"className":"arrow-svg-outer","transform":"translate(22.500000, 13.000000) rotate(-180.000000) translate(-22.500000, -13.000000) translate(1.000000, 3.000000)","stroke":"#F2979A"},[React.createElement("rect",{"className":"arrow-svg-stroke","strokeWidth":"2.6","x":"10.3","y":"7.3","width":"32","height":"6","key":0}),React.createElement("polygon",{"className":"arrow-svg-stroke","strokeWidth":"3.2","points":"9.8 0.7 9.8 19.1 0.6 9.9","key":1})]))]);
}

ArrowRight.defaultProps = {"width":"46px","height":"27px","viewBox":"0 0 46 27","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
